import { COUNTRIES, DELIMITERS } from '@emobg/web-utils';

export interface PhoneNumber {
  prefix: string;
  number: string;
}

export const getPhonePrefix = (countryCode: string): string => {
  if (!countryCode) {
    return '';
  }

  const { dialCode } = COUNTRIES.find(({ code }) => code === countryCode) || { dialCode: '' };

  return dialCode;
};

const EMPTY_PHONE = { prefix: '', number: '' } as const;

export const splitPhoneNumber = (phone: string): PhoneNumber => {
  const startsWithPrefix = phone.startsWith(DELIMITERS.plus);

  if (!startsWithPrefix) {
    return EMPTY_PHONE;
  }

  const { dialCode: prefix } = COUNTRIES.find(({ dialCode }) => phone.startsWith(dialCode)) || { dialCode: '' };

  if (!prefix) {
    return EMPTY_PHONE;
  }

  const number = phone.replace(prefix, '');

  return { prefix, number };
};
